<template>
  <div class="card m-2 p-2">
    <!-- <div class="d-flex justify-content-center mt-3">
      <div class="rounded w-90" v-bind:class="pic"></div>
    </div>
    <div class="text-center m-2">
      <p class="h1 font-weight-bold mt-4 mb-3 text-dark">{{ name }}</p>
      <p class="h3 text-primary"><strong>{{ title }}</strong></p>
      <p v-if="showBio" class="grey-text font-weight-bold">{{ bio }}</p>
      <p v-if="phone" class=""><span class="">Cell: </span><a class="externalLinksGoogleTracking" :tracking-info="'Phone Link for ' + name" :href="'tel:'+ phone">{{ phone }}</a></p>
      <p v-if="email" class=""><a class="externalLinksGoogleTracking" :tracking-info="'Email Link for' + name" :href="'mailto:'+ email">{{ email }}</a></p>
      <p class="text-white bg-grey">Resides in {{ location }}</p>
    </div>
  </div> -->
    <div class="text-right text-dark bmg-responsive-header">
      Days Remaining: {{ daysRemaining }} of {{ durationInDays }}
    </div>
    <div class="">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 40"
      >
        <title>Investments Progress Bar</title>
        <g id="ProgressOutline">
          <g
            id="Bar_Outline"
            data-name="Bar Outline"
          >
            <path
              class="bmg-invest-progress-bar-1"
              d="M999,1V19H1V1H999m1-1H0V20H1000V0Z"
            />
          </g>
          <polygon
            id="_100_Marker"
            data-name="100% Marker"
            class="bmg-invest-progress-bar-1"
            points="980 19 1000 19 990 39 980 19"
          />
        </g>
        <g id="InProcess">
          <g id="InProcessBar">
            <rect
              class="bmg-invest-progress-bar-2"
              :width="inProcessWidth"
              height="20"
            />
          </g>
          <polygon
            id="InProcessMarker"
            class="bmg-invest-progress-bar-2"
            :points="inProcessMarker"
          />
        </g>
        <g id="Raised">
          <g
            id="InProcessBar-2"
            data-name="InProcessBar"
          >
            <rect
              class="bmg-invest-progress-bar-3"
              :width="raisedWidth"
              height="20"
            />
          </g>
          <polygon
            id="InProcessMarker-2"
            data-name="InProcessMarker"
            class="bmg-invest-progress-bar-3"
            :points="raisedMarker"
          />
        </g>
      </svg>
    </div>
    <div class="centered-on-page">
      <div class="row w-100">
        <div class="col-md-4 bmg-responsive-header">
          <span class="bg-primary">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          Raised: ${{ this.formatNum(raised) }} from {{ numRaisedInvestors }} Investor{{ (numRaisedInvestors > 1) || (0 === numRaisedInvestors) ? 's': '' }}
        </div>
        <div class="col-md-6 text-center bmg-responsive-header">
          <span class="bg-secondary">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          Pending Investments: ${{ this.formatNum(processing) }} from {{ numProcessingInvestors }} Investor{{ (numProcessingInvestors > 1) || (0 === numProcessingInvestors) ? 's': '' }}
        </div>
        <div class="col-md-2 text-right bmg-responsive-header">
          Goal: <span class="uppercase">${{ this.formatNumShort(goal) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var numeral = require('numeral')

export default {
  name: 'InvestProgressBar',
  props: [
    'goal',
    'raised',
    'processing',
    'raisedInvestors',
    'processingInvestors',
    'daysRemaining',
    'durationInDays'
  ],
  data: function () {
    return {
    }
  },
  components: {},
  methods: {
    formatNum: function (num) {
      return numeral(num).format('0,0')
    },
    formatNumShort: function (num) {
      return numeral(num).format('0,0.0a')
    }
  },
  computed: {
    numRaisedInvestors: function () {
      return this.raisedInvestors ? parseInt(this.raisedInvestors) : 0
    },
    numProcessingInvestors: function () {
      return this.processingInvestors ? parseInt(this.processingInvestors) : 0
    },
    raisedWidth: function () {
      var g = parseFloat(this.goal)
      var r = parseFloat(this.raised)
      console.log('raisedWidth: 1000 * (' + r + ' / ' + g + ') = ', 1000 * (r / g))
      return 1000 * (r / g)
    },
    inProcessWidth: function () {
      var g = parseFloat(this.goal)
      var p = parseFloat(this.processing)
      console.log('inProcessWidth: (1000 * (' + p + ' / ' + g + ')) + ' + this.raisedWidth + ' = ', (1000 * (p / g)) + this.raisedWidth)
      return (1000 * (p / g)) + this.raisedWidth
    },
    raisedMarker: function () {
      // "50 10 60 10 55 20 50 10"
      var x = this.raisedWidth - 20
      return x + ' 19 ' + (x + 20) + ' 19 ' + (x + 10) + ' 39 ' + x + ' 19'
    },
    inProcessMarker: function () {
      // "480 19 500 19 490 39 480 19"
      var x = this.inProcessWidth - 20
      return x + ' 19 ' + (x + 20) + ' 19 ' + (x + 10) + ' 39 ' + x + ' 19'
    }
  },
  mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
